(function () {
    'use strict';

    var ROOT_SELECTOR = '[data-hd-hover-cards]';
    var READY_ATTR = 'data-hd-hc-ready';

    function HdHoverCardsSlider(root) {
        this.root = root;
        this.viewport = root.querySelector('[data-hd-hc-viewport]');
        this.track = root.querySelector('[data-hd-hc-track]');

        if (!this.viewport || !this.track) {
            return;
        }

        this.prevBtn = root.querySelector('[data-hd-hc-prev]');
        this.nextBtn = root.querySelector('[data-hd-hc-next]');
        this.dotsWrap = root.querySelector('[data-hd-hc-dots]');
        this.total = this.track.children.length;
        this.dots = [];
        this.lastPerView = null;

        this.snapping = false;
        this.snapReset = null;
        this.settleTimer = null;
        this.uiRAF = null;
        this.resizeT = null;
        this.observer = null;

        this.dragging = false;
        this.moved = false;
        this.startX = 0;
        this.startLeft = 0;

        this.mq1 = window.matchMedia('(max-width: 549.98px)');
        this.mq2 = window.matchMedia('(min-width: 550px) and (max-width: 899.98px)');
        this.mq3 = window.matchMedia('(min-width: 900px) and (max-width: 1199.98px)');

        this.bind();
        this.lastPerView = this.perView();
        this.buildDots(this.pageCount());
        this.refreshChrome();

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(this.refreshChrome.bind(this));
        }
    }

    HdHoverCardsSlider.prototype.perView = function () {
        if (this.mq1.matches) { return 1; }
        if (this.mq2.matches) { return 2; }
        if (this.mq3.matches) { return 3; }
        return 4;
    };

    HdHoverCardsSlider.prototype.gap = function () {
        var cs = getComputedStyle(this.track);
        var g = parseFloat(cs.columnGap || cs.gap || '0');
        return isNaN(g) ? 0 : g;
    };

    HdHoverCardsSlider.prototype.pageCount = function () {
        return Math.max(1, Math.ceil(this.total / this.perView()));
    };

    HdHoverCardsSlider.prototype.pageStride = function () {
        return this.viewport.clientWidth + this.gap();
    };

    HdHoverCardsSlider.prototype.maxScroll = function () {
        return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    };

    HdHoverCardsSlider.prototype.currentPage = function () {
        var pages = this.pageCount();
        var mx = this.maxScroll();
        var cur;

        if (mx > 0 && this.viewport.scrollLeft >= mx - 2) {
            cur = pages - 1;
        } else {
            var stride = this.pageStride();
            cur = stride > 0 ? Math.round(this.viewport.scrollLeft / stride) : 0;
        }

        return Math.min(pages - 1, Math.max(0, cur));
    };

    HdHoverCardsSlider.prototype.applyNav = function (cur) {
        var pages = this.pageCount();

        if (this.prevBtn) { this.prevBtn.disabled = cur <= 0; }
        if (this.nextBtn) { this.nextBtn.disabled = cur >= pages - 1; }

        this.dots.forEach(function (d, i) {
            var on = i === cur;
            d.classList.toggle('is-active', on);
            d.setAttribute('aria-current', on ? 'true' : 'false');
        });
    };

    HdHoverCardsSlider.prototype.buildDots = function (count) {
        if (!this.dotsWrap) { return; }

        var self = this;
        this.dotsWrap.innerHTML = '';
        this.dots = [];

        for (var i = 0; i < count; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'hd-hover-cards__dot';
            b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            (function (idx) {
                b.addEventListener('click', function () { self.goToPage(idx); });
            })(i);
            this.dotsWrap.appendChild(b);
            this.dots.push(b);
        }
    };

    HdHoverCardsSlider.prototype.refreshChrome = function () {
        var pages = this.pageCount();
        var active = pages > 1;

        this.root.classList.toggle('is-slider', active);
        this.root.classList.toggle('is-centered', !active);

        if (this.dots.length !== pages) { this.buildDots(pages); }

        if (!active) {
            if (this.prevBtn) { this.prevBtn.disabled = true; }
            if (this.nextBtn) { this.nextBtn.disabled = true; }
            this.dots.forEach(function (d) { d.classList.remove('is-active'); });
        } else {
            this.applyNav(this.currentPage());
        }
    };

    HdHoverCardsSlider.prototype.scrollToLeft = function (left, animate) {
        var self = this;

        left = Math.max(0, Math.min(left, this.maxScroll()));
        this.snapping = true;
        this.viewport.scrollTo({ left: left, behavior: animate === false ? 'auto' : 'smooth' });

        if (this.snapReset) { clearTimeout(this.snapReset); }
        this.snapReset = setTimeout(function () { self.snapping = false; }, 500);
    };

    HdHoverCardsSlider.prototype.goToPage = function (p, animate) {
        var pages = this.pageCount();

        p = Math.min(pages - 1, Math.max(0, p));
        this.scrollToLeft(p * this.pageStride(), animate);
        this.applyNav(p);
    };

    HdHoverCardsSlider.prototype.settle = function () {
        if (this.pageCount() <= 1) { return; }
        this.goToPage(this.currentPage());
    };

    HdHoverCardsSlider.prototype.bind = function () {
        var self = this;

        this.onPrev = function () { self.goToPage(self.currentPage() - 1); };
        this.onNext = function () { self.goToPage(self.currentPage() + 1); };

        this.onScroll = function () {
            if (!self.uiRAF) {
                self.uiRAF = requestAnimationFrame(function () {
                    self.uiRAF = null;
                    if (self.pageCount() > 1) { self.applyNav(self.currentPage()); }
                });
            }
            if (self.snapping) { return; }
            if (self.settleTimer) { clearTimeout(self.settleTimer); }
            self.settleTimer = setTimeout(function () { self.settle(); }, 120);
        };

        this.onViewportChange = function () {
            if (self.resizeT) { clearTimeout(self.resizeT); }
            self.resizeT = setTimeout(function () {
                var pv = self.perView();
                if (pv !== self.lastPerView) {
                    self.lastPerView = pv;
                    self.refreshChrome();
                    self.goToPage(0, false);
                } else {
                    self.refreshChrome();
                    self.goToPage(self.currentPage(), false);
                }
            }, 150);
        };

        this.onDragStart = function (e) { e.preventDefault(); };

        this.onPointerDown = function (e) {
            if (e.pointerType === 'touch' || e.button !== 0 || self.pageCount() <= 1) { return; }
            self.dragging = true;
            self.moved = false;
            self.startX = e.clientX;
            self.startLeft = self.viewport.scrollLeft;
            e.preventDefault();
        };

        this.onPointerMove = function (e) {
            if (!self.dragging) { return; }
            var dx = e.clientX - self.startX;
            if (!self.moved && Math.abs(dx) > 4) {
                self.moved = true;
                self.viewport.classList.add('is-grabbing');
            }
            if (self.moved) { self.viewport.scrollLeft = self.startLeft - dx; }
        };

        this.onDragEnd = function () {
            if (!self.dragging) { return; }
            self.dragging = false;
            self.viewport.classList.remove('is-grabbing');
            if (self.moved) { self.settle(); }
        };

        this.onClickCapture = function (e) {
            if (self.moved) {
                e.preventDefault();
                e.stopPropagation();
                self.moved = false;
            }
        };

        if (this.prevBtn) { this.prevBtn.addEventListener('click', this.onPrev); }
        if (this.nextBtn) { this.nextBtn.addEventListener('click', this.onNext); }

        this.viewport.addEventListener('scroll', this.onScroll);
        this.viewport.addEventListener('dragstart', this.onDragStart);
        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        this.viewport.addEventListener('click', this.onClickCapture, true);

        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onDragEnd);
        window.addEventListener('pointercancel', this.onDragEnd);
        window.addEventListener('resize', this.onViewportChange);

        [this.mq1, this.mq2, this.mq3].forEach(function (mq) {
            if (mq.addEventListener) { mq.addEventListener('change', self.onViewportChange); }
            else if (mq.addListener) { mq.addListener(self.onViewportChange); }
        });

        if (window.ResizeObserver) {
            this.observer = new ResizeObserver(this.onViewportChange);
            this.observer.observe(this.viewport);
        }
    };

    HdHoverCardsSlider.prototype.destroy = function () {
        var self = this;

        if (!this.viewport || !this.track) { return; }

        if (this.prevBtn) { this.prevBtn.removeEventListener('click', this.onPrev); }
        if (this.nextBtn) { this.nextBtn.removeEventListener('click', this.onNext); }

        this.viewport.removeEventListener('scroll', this.onScroll);
        this.viewport.removeEventListener('dragstart', this.onDragStart);
        this.viewport.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport.removeEventListener('click', this.onClickCapture, true);

        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onDragEnd);
        window.removeEventListener('pointercancel', this.onDragEnd);
        window.removeEventListener('resize', this.onViewportChange);

        [this.mq1, this.mq2, this.mq3].forEach(function (mq) {
            if (mq.removeEventListener) { mq.removeEventListener('change', self.onViewportChange); }
            else if (mq.removeListener) { mq.removeListener(self.onViewportChange); }
        });

        if (this.observer) { this.observer.disconnect(); }
        if (this.snapReset) { clearTimeout(this.snapReset); }
        if (this.settleTimer) { clearTimeout(this.settleTimer); }
        if (this.resizeT) { clearTimeout(this.resizeT); }
        if (this.uiRAF) { cancelAnimationFrame(this.uiRAF); }
    };

    function init(context) {
        var scope = context && context.querySelectorAll ? context : document;
        var roots = scope.querySelectorAll(ROOT_SELECTOR);

        for (var i = 0; i < roots.length; i++) {
            if (roots[i].getAttribute(READY_ATTR)) { continue; }
            roots[i].setAttribute(READY_ATTR, 'true');
            roots[i].hdHoverCards = new HdHoverCardsSlider(roots[i]);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
        init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
        init(event.target || document);
    });

    document.addEventListener('shopify:section:unload', function (event) {
        var target = event.target;
        if (!target || !target.querySelectorAll) { return; }

        var roots = target.querySelectorAll(ROOT_SELECTOR);
        for (var i = 0; i < roots.length; i++) {
            if (roots[i].hdHoverCards && roots[i].hdHoverCards.destroy) {
                roots[i].hdHoverCards.destroy();
            }
            roots[i].hdHoverCards = null;
            roots[i].removeAttribute(READY_ATTR);
        }
    });
})();
